<template>
	<div class="root-wrap">
		<div class="fx-fill fx-center-middle">
			<div class="pt98 errBox fx-center-middle">
				<img class="errIco" :src="require('@/assets/images/error/err.png')" alt />
				<h4>页面失联了，攻城狮正在紧急搜索中...</h4>
				<p>· 可能原因：{{ errorCode || 'xxxx' }}</p>
				<p>· 错误代码：{{ errorMsg || '认证失败' }}</p>
				<!-- <div @click="refresh" class="refresh fr ac jc">
                    <img src="../../../static/imgs/movie/refresh.png" alt />
                    <span>刷新</span>
                </div> -->
			</div>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			errorCode: this.$route.query.errorCode,
			errorMsg: this.$route.query.errorMsg,
		}
	}
}
</script>

<style lang="scss" scoped>
.errBox {
	.errIco {
		width: 150px;
		height: 150px;
	}

	h4 {
		font-size: 16px;
		margin: 0 0 20px 0;
	}

	p {
		width: 100%;
		font-size: 14px;
		color: #818181;
	}

	.refresh {
		width: 200px;
		height: 70px;
		font-size: 28px;
		background: #fff;
		margin: 50px 0;
		border-radius: 10px;
		color: #ec642b;
		border: 1px solid #ec642b;

		img {
			width: 40px;
			height: 40px;
			margin-right: 20px;
		}
	}
}
</style>
